/**
 * V2 destination collectionId → Hardhat CONTRACT_KIND for ERC721 UUPS only.
 * Source: config/v2DestinationContractKinds.json (sync with server collectionContractKind.js).
 *
 * Unwraps `import x from '*.json'` when the bundler nests the object under `.default`
 * (otherwise UI lookups like map[collectionId] stay empty when you change the dropdown).
 */
import raw from '../../config/v2DestinationContractKinds.json';

function unwrapJsonModule(m) {
  if (
    m &&
    typeof m === 'object' &&
    'default' in m &&
    m.default &&
    typeof m.default === 'object' &&
    !Array.isArray(m.default)
  ) {
    return m.default;
  }
  return m;
}

const DATA = unwrapJsonModule(raw);

/** Ptadmin / current V2 program: only ERC721 preserve + reissue. ParadiseERC1155 is not in the rollout. */
const VALID_KINDS = new Set(['preserve', 'reissue']);

export function getContractKindForCollectionId(collectionId) {
  if (!collectionId || typeof collectionId !== 'string') {
    return '';
  }
  const v = DATA[collectionId];
  if (typeof v !== 'string' || !VALID_KINDS.has(v)) {
    return '';
  }
  return v;
}
